import { Alert } from "@vinomofo/components";

interface ToastProps {
  label?: string;
  message?: string;
}

export const ErrorToast = ({
  label = "Uh-oh!",
  message = "",
}: ToastProps): JSX.Element => {
  return (
    <Alert
      padding={1}
      px={1}
      boxShadow="none"
      intent="error"
      label={label}
      message={message}
    />
  );
};
